import { api, brl } from "./api";

export const waNumber = (raw) => {
  let d = (raw || "").replace(/\D/g, "").replace(/^0+/, "");
  if (!(d.startsWith("55") && d.length > 11)) d = `55${d}`;
  return d;
};

export const waLink = (number, text) =>
  `https://wa.me/${waNumber(number)}${text ? `?text=${encodeURIComponent(text)}` : ""}`;

const productUrl = (slug) => `${window.location.origin}/perfume/${slug}`;

export const singleMessage = (p) =>
  `Olá! Tenho interesse no perfume ${p.name}, no valor de ${brl(p.final_price)}. Gostaria de mais informações sobre a disponibilidade.\n${productUrl(p.slug)}`;

export const multiMessage = (items) => {
  const lines = items.map(
    (i, n) => `${n + 1}. ${i.name} (${i.brand}, ${i.volume_ml}ml) — ${i.qty}x ${brl(i.final_price)}\n${productUrl(i.slug)}`
  );
  const total = items.reduce((s, i) => s + i.final_price * i.qty, 0);
  return `Olá! Tenho interesse nos seguintes perfumes:\n\n${lines.join("\n\n")}\n\nTotal estimado: ${brl(total)}\nGostaria de mais informações sobre a disponibilidade.`;
};

export const logRequest = (items) => {
  api.post("/requests", { items: items.map((i) => ({ product_id: i.id, qty: i.qty || 1 })) }).catch(() => {});
};
